import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Actions
import { pesquisa as pesquisaevento, eventoselecionado } from '../../../../actions/eventos/eventos';

//Components
import Menus from './Menus';
import ModalSelecionaEvento from './ModalSelecionaEvento';

//Utils
import { setEvento, getEvento } from '../../../../utils/eventosession';
import CookiesSite  from '../../../../utils/CookiesSite';
import { removeUserGeren, getUserGeren } from '../../../../utils/authusuariogerenciamento';

class DashboardMenu extends React.Component {

    state = {
        selecionaevento: false,
        edicaoevento: false,
        menuclicado: false
    }

    user =  getUserGeren()

    componentDidMount(){        
        const edicao = new Date();        
        this.setState({
            edicaoevento: edicao.getFullYear()
        });
        
        if(this.user&&this.user.idpromotora){
            this.props.pesquisaevento({idpromotora: this.user.idpromotora});
        }
    }

    handleMenu = (selected) => {

        const eventosession = getEvento();
        const evento_selecionado = (this.props.eventoatual.idevento)||(eventosession&&eventosession.idevento)?true:false;
        
        if(selected === 'selecionaevento'){
            this.handleModalEvento('/gerenciamento/dashboard');//Seleciona Evento
        }else if(selected === 'login/sair'){
            this.handleSair();
        }else if(selected === 'login'){
            this.props.history.push(`/gerenciamento/${selected}`);
        }else{
            if(this.user&&this.user.id){            
                if(evento_selecionado){                    
                    this.props.history.push(`/gerenciamento/${selected}`);
                }else{
                    this.handleModalEvento(selected);
                }
            }
        }
    }

    handleModalEvento = (selected) => {        
        this.setState({
            selecionaevento: !this.state.selecionaevento?true:false,
            menuclicado: selected //trancking menu clicado sem evento selecionado
        });
    }

    handleSair = () => {

        removeUserGeren();
        setEvento({});
        this.user = null;
        this.props.eventoselecionado({})
        
        this.setState({
            selecionaevento: false,
            menuclicado: false
        });
        this.props.history.push(`/gerenciamento/dashboard`);
    }

    handleSelesionaEvento = (form) => {
        const evento = JSON.parse(form.evento);
        this.props.eventoselecionado(evento);        
        setEvento(evento);
        this.setState({
            selecionaevento: !this.state.selecionaevento?true:false
        });
        setTimeout(() => {
            this.props.history.push(`${this.state.menuclicado}`);
        },500)        
    }

    handleEdicao = (edicao) => {
        this.setState({
            edicaoevento: parseInt(edicao)
        })
    }

    render() {        
        
        return (
            <>
            <ModalSelecionaEvento 
            edicaoevento={this.state.edicaoevento} 
            selecionaevento={this.state.selecionaevento} 
            eventos={this.props.eventos}
            handleEdicao={this.handleEdicao}
            handleModalEvento={this.handleModalEvento}
            handleSelesionaEvento={this.handleSelesionaEvento}
            pendingTasks={this.props.pendingTasks}
            />
            <Menus 
            handleMenu={this.handleMenu} 
            user={this.user} 
            />            
            <CookiesSite idpromotora={this.user.idpromotora} />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        eventos: state.reducerPesquisaEventos,
        eventoatual: state.reducerEventoSelecionado,
        pendingTasks: state.pendingTasks
    }
}

export default connect(mapStateToProps,{pesquisaevento,eventoselecionado})(withRouter(DashboardMenu));